import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useEffect } from 'react';
import { useCurrentPaymentTask } from '@/providers/PaymentTaskProvider';
import { usePaymentTaskFixedAssets } from '@/hooks/api/1150_payment_task_fixed_assets';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useFixedAssets } from '@/hooks/api/2000_fixed_assets';
import { PaymentTaskLogic } from '@/hooks/api/models/logics';
import { PaymentTaskFixedAssetCreateForm } from '@/components/features/tasks/payment/[payment_task_id]/PaymentTaskFixedAssetEditForm/PaymentTaskFixedAssetCreateForm';
import { PaymentTaskFixedAssetsElement } from '@/components/features/tasks/payment/[payment_task_id]/PaymentTaskFixedAssetEditForm/PaymentTaskFixedAssetsElement';

export const PaymentTaskFixedAssetEditForm = () => {
  const navigate = useNavigate();
  const { _w_, _t_, me } = useCurrentTeamMember();
  const { purchase_order_id } = useParams();
  const { paymentTask: task } = useCurrentPaymentTask();
  const { data: fixedAssetsResp } = useFixedAssets({
    identifier: _w_!.identifier,
    page: 1,
    per: 1000,
    fixed_asset_status_id: 1,
  });
  const { data: paymentTaskFixedAssets } = usePaymentTaskFixedAssets({
    identifier: _w_!.identifier,
    team_id: _t_!.id,
    purchase_order_id: Number(purchase_order_id),
    task_id: task!.id,
  });

  useEffect(() => {
    if (task!.payment_amount == null) navigate(-1);
  }, []);

  if (fixedAssetsResp == null || paymentTaskFixedAssets == null) return <></>;

  return (
    <div className="container-fluid py-4">
      <div className="row">
        <div className="col-12 col-lg-9 mx-auto">
          <div className="card mb-4" id="basic-info">
            <div className="card-header d-flex align-items-center">
              <div className="col-md-8">
                <h5 className="mb-1">固定資産金額の投入</h5>
                <p className="text-xs mb-0">請求金額のうち、固定資産と固定資産外費用を分類してください。</p>
              </div>
            </div>
            <div className="card-body pt-0 row">
              <div className="form-group">
                <label>タスク名</label>
                <p className="form-text text-muted text-sm ms-1">{task!.name}</p>
              </div>
              <div className="d-flex justify-content-end">
                <div className="table-responsive">
                  <table className="table align-items-center">
                    <thead>
                      <tr>
                        <th
                          className="text-secondary text-xxs font-weight-bolder opacity-7 px-2 text-end"
                          style={{ width: 150 }}
                        >
                          投入金額合計
                        </th>
                        <th
                          className="text-secondary text-xxs font-weight-bold opacity-7 px-2 text-end"
                          style={{ width: 150 }}
                        >
                          未分類金額合計
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="text-end text-dark text-xs">
                          ¥{PaymentTaskLogic.categorizedAmount(task!, paymentTaskFixedAssets).toLocaleString()}
                        </td>
                        <td className="text-end text-dark text-xs">
                          ¥{PaymentTaskLogic.unCategorizedAmount(task!, paymentTaskFixedAssets).toLocaleString()}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <hr className="horizontal dark my-3" />

              <PaymentTaskFixedAssetCreateForm
                fixedAssets={fixedAssetsResp.fixed_assets}
                paymentTaskFixedAssets={paymentTaskFixedAssets}
              />

              <hr className="horizontal dark my-3" />

              <PaymentTaskFixedAssetsElement paymentTaskFixedAssets={paymentTaskFixedAssets} />
            </div>
            <div className="card-footer d-flex align-items-center justify-content-end pt-0">
              <Link to="" className="btn btn-outline-secondary" onClick={() => navigate(-1)}>
                支払タスク詳細へ
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
